module.exports = {"513338101":"瓦卡镇","513338102":"白松镇","513338103":"日雨镇","513338104":"太阳谷镇","513338201":"徐龙乡","513338204":"奔都乡","513338205":"八日乡","513338206":"古学乡","513338208":"贡波乡","513338210":"茨巫乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513338.json
// module id = 2560
// module chunks = 0